<div class="ia-view-picker" role="group" aria-label="Saved table views">
  <span class="ia-view-picker__label">Saved view</span>
  <div *ngIf="dropdown; else viewButtons" ngbDropdown #savedViews="ngbDropdown">
    <button type="button" class="btn btn-sm btn-outline-secondary" ngbDropdownToggle
      [attr.aria-label]="'Saved table view: ' + (selected?.name || selected?.gridId || 'Choose a view')">
      {{ (selected?.name || selected?.gridId || 'Saved views') | titlecase }}
    </button>
    <div ngbDropdownMenu>
      <button type="button" ngbDropdownItem *ngFor="let view of views"
        [attr.aria-pressed]="view === selected" (click)="viewChange.emit(view); savedViews.close()">
        {{ (view.name || view.gridId) | titlecase }}
      </button>
    </div>
  </div>
  <ng-template #viewButtons>
    <button type="button" *ngFor="let view of views" class="ia-view-picker__view"
      [class.ia-view-picker__view--selected]="view === selected" [attr.aria-pressed]="view === selected"
      (click)="viewChange.emit(view)">{{ (view.name || view.gridId) | titlecase }}</button>
  </ng-template>
  <button type="button" class="btn btn-sm btn-outline-secondary" aria-label="Create saved view"
    (click)="createView.emit()"><span aria-hidden="true">+</span> New view</button>
</div>
